<template>
  <div class="gov-shell">
    <div class="gov-tab-bar" v-if="tabs.length > 0">
      <div
        class="gov-tab"
        :class="{ active: activeTab === 'home' }"
        @click="activeTab = 'home'"
      >
        <span class="tab-title">指标定义智能体</span>
      </div>
      <div
        v-for="tab in tabs"
        :key="tab.id"
        class="gov-tab"
        :class="{ active: activeTab === tab.id }"
        @click="activeTab = tab.id"
      >
        <span class="tab-title">{{ tab.title }}</span>
        <i class="el-icon-close tab-close" @click.stop="closeTab(tab.id)"></i>
      </div>
    </div>

    <div v-show="activeTab === 'home'">
      <AgentLayout
        agentType="indicator"
        title="指标定义智能体"
        description="一站式指标管理平台，支持原子、派生、复合三类指标的统一定义与管理"
        placeholder="输入指标相关问题，按 Enter 发送..."
        @send="handleSend"
      >
        <div class="indicator-board">
          <!-- <div class="quick-questions">
        <button
          v-for="item in quickQuestions"
          :key="item.scene"
          type="button"
          class="question-item"
          @click="handleSceneClick(item.scene)"
        >
          <span class="q-icon">
            <i :class="item.icon"></i>
          </span>
          <span class="q-text">{{ item.text }}</span>
        </button>
      </div> -->

          <div class="stats-row">
            <div class="stat-list">
              <div v-for="stat in stats" :key="stat.label" class="stat-card" @click="handleStatClick(stat)">
                <span class="stat-icon" :class="stat.type">
                  <i :class="stat.icon"></i>
                </span>
                <div class="stat-info">
                  <span class="stat-value">{{ stat.value }}</span>
                  <span class="stat-label">{{ stat.label }}</span>
                </div>
              </div>
            </div>

            <div class="trend-card">
              <div class="trend-head">
                <span>指标增长趋势</span>
                <strong
                  ><i class="el-icon-top"></i> {{ trendGrowthText }}</strong
                >
              </div>
              <div class="mini-chart">
                <span
                  v-for="(bar, index) in trendBars"
                  :key="index"
                  :style="{ height: bar + '%' }"
                ></span>
              </div>
            </div>
          </div>

          <section
            v-if="showBuildCard"
            class="scene-card build-card"
            @click="
              handleOpenTab(
                'intelligent-indicator-system',
                '智能构建指标体系',
                BIGDATA_PATHS.intelligentIndicatorSystem,
              )
            "
          >
            <div class="card-head">
              <div class="card-title-wrap">
                <span class="feature-icon">
                  <i class="el-icon-magic-stick"></i>
                </span>
                <div>
                  <h3>智能构建指标体系</h3>
                  <p>从行业指标库选择模板，自动构建指标体系</p>
                </div>
              </div>
              <button
                type="button"
                class="link-pill"
                @click.stop="
                  handleOpenTab(
                    'intelligent-indicator-system',
                    '智能构建指标体系',
                    BIGDATA_PATHS.intelligentIndicatorSystem,
                  )
                "
              >
                开始构建
                <i class="el-icon-right"></i>
              </button>
            </div>

            <div class="build-flow">
              <div
                v-for="(step, index) in buildSteps"
                :key="step.title"
                class="flow-item"
              >
                <div class="flow-content">
                  <div class="flow-title">
                    <span>{{ index + 1 }}</span>
                    <strong>{{ step.title }}</strong>
                  </div>
                  <p v-html="step.desc"></p>
                </div>
                <i
                  v-if="index < buildSteps.length - 1"
                  class="el-icon-arrow-right flow-arrow"
                ></i>
              </div>
            </div>
          </section>

          <div class="feature-grid">
            <section
              class="scene-card"
              @click="
                handleOpenTab(
                  'indicator-definition',
                  '指标清单',
                  BIGDATA_PATHS.indicatorDefinition,
                )
              "
            >
              <div class="card-head">
                <div class="card-title-wrap">
                  <span class="feature-icon">
                    <i class="el-icon-s-order"></i>
                  </span>
                  <div>
                    <h3>指标清单</h3>
                    <p>全部已定义指标，支持筛选搜索</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="link-pill"
                  @click.stop="
                    handleOpenTab(
                      'indicator-definition',
                      '指标清单',
                      BIGDATA_PATHS.indicatorDefinition,
                    )
                  "
                >
                  查看全部
                  <i class="el-icon-right"></i>
                </button>
              </div>

              <div class="metric-table">
                <div class="table-row table-head">
                  <span>指标名称</span>
                  <span>类型</span>
                  <span>分类</span>
                </div>
                <div
                  v-for="metric in metricRows"
                  :key="metric.name"
                  class="table-row"
                >
                  <span>{{ metric.name }}</span>
                  <span>
                    <em class="type-tag" :class="metric.typeClass">{{
                      metric.type
                    }}</em>
                  </span>
                  <span>{{ metric.category }}</span>
                </div>
                <div class="table-footer">共 {{ metricTotal }} 项指标</div>
              </div>
            </section>

            <section
              class="scene-card"
              @click="
                handleOpenTab(
                  'indicator-element',
                  '指标要素',
                  BIGDATA_PATHS.indicatorElement,
                )
              "
            >
              <div class="card-head">
                <div class="card-title-wrap">
                  <span class="feature-icon">
                    <i class="el-icon-s-grid"></i>
                  </span>
                  <div>
                    <h3>指标要素</h3>
                    <p>管理三类要素，支撑规范化定义</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="link-pill"
                  @click.stop="
                    handleOpenTab(
                      'indicator-element',
                      '指标要素',
                      BIGDATA_PATHS.indicatorElement,
                    )
                  "
                >
                  查看全部
                  <i class="el-icon-right"></i>
                </button>
              </div>

              <div class="element-panel">
                <div class="element-summary">
                  <div
                    v-for="item in elementStats"
                    :key="item.label"
                    class="element-stat"
                  >
                    <span><i :class="item.icon"></i></span>
                    <strong>{{ item.value }}</strong>
                    <small>{{ item.label }}</small>
                  </div>
                </div>
                <div class="panel-footer">
                  共 3 类 · {{ totalElementCount }} 个要素
                </div>
              </div>
            </section>

            <!-- 计量单位 -->
            <section
              class="scene-card"
              @click="
                handleOpenTab(
                  'indicator-unit',
                  '计量单位',
                  BIGDATA_PATHS.indicatorUnit,
                )
              "
            >
              <div class="card-head">
                <div class="card-title-wrap">
                  <span class="feature-icon">
                    <i class="el-icon-s-flag"></i>
                  </span>
                  <div>
                    <h3>计量单位</h3>
                    <p>管理指标计量单位与分类</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="link-pill"
                  @click.stop="
                    handleOpenTab(
                      'indicator-unit',
                      '计量单位',
                      BIGDATA_PATHS.indicatorUnit,
                    )
                  "
                >
                  查看全部
                  <i class="el-icon-right"></i>
                </button>
              </div>
              <div class="metric-table">
                <div class="table-row table-head">
                  <span>单位名称</span>
                  <span>所属分类</span>
                </div>
                <div
                  v-for="unit in unitRows"
                  :key="unit.name"
                  class="table-row"
                >
                  <span>{{ unit.name }}</span>
                  <span>{{ unit.typeName }}</span>
                </div>
                <div class="table-footer">共 {{ unitTotal }} 项单位</div>
              </div>
            </section>

            <!-- 标签管理 -->
            <section
              class="scene-card"
              @click="
                handleOpenTab(
                  'indicator-labels',
                  '标签管理',
                  BIGDATA_PATHS.indicatorLabels,
                )
              "
            >
              <div class="card-head">
                <div class="card-title-wrap">
                  <span class="feature-icon">
                    <i class="el-icon-price-tag"></i>
                  </span>
                  <div>
                    <h3>标签管理</h3>
                    <p>管理指标文本标签与编码</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="link-pill"
                  @click.stop="
                    handleOpenTab(
                      'indicator-labels',
                      '标签管理',
                      BIGDATA_PATHS.indicatorLabels,
                    )
                  "
                >
                  查看全部
                  <i class="el-icon-right"></i>
                </button>
              </div>
              <div class="metric-table">
                <div class="table-row table-head">
                  <span>标签名称</span>
                  <span>标签编码</span>
                </div>
                <div
                  v-for="label in labelRows"
                  :key="label.name"
                  class="table-row"
                >
                  <span>{{ label.name }}</span>
                  <span>{{ label.code }}</span>
                </div>
                <div class="table-footer">共 {{ labelTotal }} 项标签</div>
              </div>
            </section>

            <!-- 指标血缘 -->
            <section
              class="scene-card"
              @click="
                handleOpenTab('blood-map', '指标血缘', BIGDATA_PATHS.blood)
              "
            >
              <div class="card-head">
                <div class="card-title-wrap">
                  <span class="feature-icon">
                    <i class="el-icon-share"></i>
                  </span>
                  <div>
                    <h3>指标血缘</h3>
                    <p>分析指标上下游依赖关系</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="link-pill"
                  @click.stop="
                    handleOpenTab('blood-map', '指标血缘', BIGDATA_PATHS.blood)
                  "
                >
                  查看全部
                  <i class="el-icon-right"></i>
                </button>
              </div>
              <div class="lineage-preview-wrap">
                <div class="lineage-preview-scroll">
                  <div
                    v-for="item in lineagePreview"
                    :key="item.name"
                    class="lineage-item"
                  >
                    <span class="lineage-badge indicator">{{
                      TYPE_DESC[item.type]
                    }}</span>
                    <div class="lineage-info">
                      <div class="lineage-name">{{ item.name }}</div>
                      <div class="lineage-deps">{{ item.deps }}</div>
                    </div>
                    <span class="lineage-count">{{
                      (item.downstream && item.downstream.length) || 0
                    }}
                    下游</span
                    >
                  </div>
                </div>
                <div class="lineage-footer">
                  共
                  {{ (lineagePreview && lineagePreview.length) || 0 }}
                  条血缘关系
                </div>
              </div>
            </section>

            <section
              class="scene-card"
              @click="
                handleOpenTab(
                  'industry-indicator-library',
                  '行业指标库',
                  BIGDATA_PATHS.industryIndicatorLibrary,
                )
              "
            >
              <div class="card-head">
                <div class="card-title-wrap">
                  <span class="feature-icon">
                    <i class="el-icon-coin"></i>
                  </span>
                  <div>
                    <h3>行业指标库</h3>
                    <p>汇聚多行业可复用指标资产</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="link-pill"
                  @click.stop="
                    handleOpenTab(
                      'industry-indicator-library',
                      '行业指标库',
                      BIGDATA_PATHS.industryIndicatorLibrary,
                    )
                  "
                >
                  查看全部
                  <i class="el-icon-right"></i>
                </button>
              </div>

              <div class="industry-list">
                <div
                  v-for="industry in industries"
                  :key="industry.id || industry.name"
                  class="industry-item"
                >
                  <span class="item-icon">
                    <i :class="industry.icon"></i>
                  </span>
                  <div>
                    <strong>{{ industry.name }}</strong>
                    <p>{{ industry.desc }}</p>
                  </div>
                  <em>{{ industry.count }} 项</em>
                </div>
                <div class="panel-footer">
                  共 {{ industryTotal }} 行业 · {{ industryMetricTotal }} 项指标
                </div>
              </div>
            </section>

            <section
              class="scene-card"
              @click="
                handleOpenTab(
                  'indicator-directory',
                  '指标目录',
                  BIGDATA_PATHS.indicatorDirectory,
                )
              "
            >
              <div class="card-head">
                <div class="card-title-wrap">
                  <span class="feature-icon">
                    <i class="el-icon-s-operation"></i>
                  </span>
                  <div>
                    <h3>指标目录</h3>
                    <p>按维度组织分类，快速定位业务指标</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="link-pill"
                  @click.stop="
                    handleOpenTab(
                      'indicator-directory',
                      '指标目录',
                      BIGDATA_PATHS.indicatorDirectory,
                    )
                  "
                >
                  查看全部
                  <i class="el-icon-right"></i>
                </button>
              </div>

              <div class="directory-list">
                <div
                  v-for="item in directories"
                  :key="item.id || item.name"
                  class="directory-item"
                >
                  <span
                    ><i class="el-icon-folder-opened"></i>{{ item.name }}</span
                  >
                  <em>{{ item.count }} 项</em>
                </div>
              </div>
            </section>
          </div>
        </div>
      </AgentLayout>
    </div>

    <div
      v-for="tab in tabs"
      v-show="activeTab === tab.id"
      :key="tab.id"
      class="gov-iframe-wrap"
    >
      <iframe
        :src="tab.url"
        frameborder="0"
        class="gov-iframe"
        @load="onIframeLoad($event, tab)"
      ></iframe>
    </div>
  </div>
</template>

<script>
import AgentLayout from './agentLayout.vue'
import request from '@/utils/request'
import { BIGDATA_PATHS } from './bigdataPath'
import { getToken } from '@/utils/auth'

const TYPE_DESC = { 0: '原子指标', 1: '派生指标', 2: '复合指标' }

const UNIT_TYPES = [
  { value: '01', label: '长度' },
  { value: '02', label: '重量' },
  { value: '03', label: '容积' },
  { value: '04', label: '面积' },
  { value: '05', label: '金额' },
  { value: '06', label: '时间' },
  { value: '07', label: '数量' },
  { value: '08', label: '密度' },
  { value: '09', label: '温度' },
  { value: '10', label: '比率' },
  { value: '11', label: '热功' },
  { value: '12', label: '能力' },
  { value: '13', label: '单价' },
  { value: '14', label: '无度量' }
]

const bigdataUrl = '/tianshu-api/bigdata'
const COMMON_REQUEST_PARAMS = {
  // tenantId: 100019241,
  // createBy: "ybznt@cosmo.com",
  // createByName: "周琪",
}
const CATEGORY_TREE_REQUEST_PARAMS = {
  // tenantId: 393388,
  // createBy: "zhaoyue1@haier.com",
  // createByName: "赵越1",
}

export default {
  name: 'IndicatorAgentPage',
  components: { AgentLayout },
  data() {
    return {
      quickQuestions: [
        {
          scene: '指标清单',
          icon: 'el-icon-s-order',
          text: '当前有哪些指标？'
        },
        {
          scene: '指标目录',
          icon: 'el-icon-s-operation',
          text: '指标是如何分类的？'
        },
        {
          scene: '指标要素',
          icon: 'el-icon-s-grid',
          text: '指标包含哪些要素？'
        },
        {
          scene: '行业指标库',
          icon: 'el-icon-coin',
          text: '行业标杆指标有哪些？'
        }
      ],
      stats: [
        {
          icon: 'el-icon-magic-stick',
          value: '11',
          label: '原子指标',
          type: 'atomic'
        },
        {
          icon: 'el-icon-circle-check',
          value: '10',
          label: '派生指标',
          type: 'derived'
        },
        {
          icon: 'el-icon-s-grid',
          value: '5',
          label: '复合指标',
          type: 'composite'
        }
      ],
      trendGrowthRate: 12.5,
      trendBars: [45, 55, 50, 65, 72, 60, 80],
      buildSteps: [
        { title: '选择行业指标库', desc: '从制造业、化工、<br>PCBA中选择模板' },
        { title: '分析数据库', desc: '扫描4个数据源<br>发现数据表' },
        { title: '分析数据表', desc: '解析字段结构<br>识别主键注释' },
        { title: '构建指标体系', desc: '自动匹配指标模板<br>生成指标定义' },
        { title: '生成指标列表', desc: '逐条生成<br>待审核确认' },
        { title: '确认指标', desc: '审核确认<br>全部80项指标' }
      ],
      metricRows: [
        {
          name: '销量',
          type: '原子指标',
          typeClass: 'atomic',
          category: '销量管理'
        },
        {
          name: '实际毛利',
          type: '原子指标',
          typeClass: 'atomic',
          category: '毛利管理'
        },
        {
          name: '毛利率',
          type: '复合指标',
          typeClass: 'composite',
          category: '毛利管理'
        },
        {
          name: '销售收入',
          type: '原子指标',
          typeClass: 'atomic',
          category: '收入费用'
        }
      ],
      metricTotal: 80,
      elementStats: [
        { icon: 'el-icon-box', value: '8', label: '指标对象' },
        { icon: 'el-icon-edit-outline', value: '10', label: '度量词' },
        { icon: 'el-icon-price-tag', value: '10', label: '附加词' }
      ],
      industries: [
        // {
        //   icon: "el-icon-office-building",
        //   name: "制造业",
        //   desc: "销售业绩、售前商机、发运变现等",
        //   count: "80",
        // },
        // {
        //   icon: "el-icon-data-analysis",
        //   name: "化工行业",
        //   desc: "化工生产、工艺控制、安全环保等",
        //   count: "12",
        // },
        // {
        //   icon: "el-icon-cpu",
        //   name: "PCBA行业",
        //   desc: "SMT贴片、DIP插件、测试组装等",
        //   count: "10",
        // },
      ],
      industryTotal: 3,
      directories: [
        { name: '组织业绩', count: '26' },
        { name: '售前', count: '15' },
        { name: '售中', count: '2' },
        { name: '售后', count: '3' },
        { name: '市场及客户', count: '17' },
        { name: '变现能力', count: '6' },
        { name: '人员', count: '5' },
        { name: '风险', count: '6' }
      ],
      unitRows: [],
      unitTotal: 0,
      labelRows: [],
      labelTotal: 0,
      lineagePreview: [],
      BIGDATA_PATHS,
      TYPE_DESC,
      activeTab: "home",
      tabs: [],
      showBuildCard: false,
    };
  },
  mounted() {
    this.fetchDashboardData();
    this.checkTenantVisibility();
  },
  methods: {
    async fetchDashboardData() {
      await Promise.all([
        this.fetchIndicatorCounts(),
        this.fetchIndicatorTrend(),
        this.fetchElementCounts(),
        this.fetchMetricPage(),
        this.fetchIndustryModels(),
        this.fetchCategoryTree(),
        this.fetchUnitPage(),
        this.fetchLabelTree(),
        this.fetchLineagePreview()
      ])
    },
    async fetchIndicatorCounts() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind/matrix/counts`,
          method: 'get',
          params: { ...COMMON_REQUEST_PARAMS }
        })
        const data = res?.data?.data || {}
        this.updateStatValue('原子指标', data.atomicCount)
        this.updateStatValue('派生指标', data.derivedCount)
        this.updateStatValue('复合指标', data.compositeCount)
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchIndicatorCounts failed:', e)
      }
    },
    async fetchIndicatorTrend() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind-base-data/remark`,
          method: 'get',
          params: {
            ...COMMON_REQUEST_PARAMS,
            name: 'Indicator'
          }
        })
        const remark = this.safeParseRemark(res?.data?.data?.remark)
        const trend = remark?.data?.trend || {}
        if (Number.isFinite(Number(trend.growthRate))) {
          this.trendGrowthRate = Number(trend.growthRate)
        }
        if (Array.isArray(trend.bars) && trend.bars.length > 0) {
          this.trendBars = this.normalizeTrendBars(trend.bars)
        }
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchIndicatorTrend failed:', e)
      }
    },
    async fetchElementCounts() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind/v2/elements/counts`,
          method: 'get',
          params: { ...COMMON_REQUEST_PARAMS }
        })
        const data = res?.data?.data || {}
        this.updateElementValue('指标对象', data.objectCount)
        this.updateElementValue('度量词', data.measureWordCount)
        this.updateElementValue('附加词', data.additionalWordCount)
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchElementCounts failed:', e)
      }
    },
    async fetchMetricPage() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind/matrix/page`,
          method: 'post',
          data: {
            ...COMMON_REQUEST_PARAMS,
            pageNum: 1,
            pageSize: 4,
            keyword: ''
          }
        })
        const data = res?.data?.data || {}
        if (Number.isFinite(Number(data.total))) {
          this.metricTotal = Number(data.total)
        }
        if (Array.isArray(data.records) && data.records.length > 0) {
          this.metricRows = data.records.slice(0, 4).map(this.mapMetricRow)
        }
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchMetricPage failed:', e)
      }
    },
    async fetchIndustryModels() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind/industry-model/page`,
          method: 'post',
          data: {
            ...CATEGORY_TREE_REQUEST_PARAMS,
            keyword: '',
            pageNum: 1,
            pageSize: 10,
          },
        });
        const data = res?.data || {};
        const records = data.records || [];
        if (Number.isFinite(Number(data.total))) {
          this.industryTotal = Number(data.total)
        }
        if (Array.isArray(records) && records.length > 0) {
          this.industries = records.slice(0, 3).map(this.mapIndustryRow);
        }
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchIndustryModels failed:', e)
      }
    },
    async fetchCategoryTree() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind/v2/categories/tree`,
          method: 'get',
          params: { ...CATEGORY_TREE_REQUEST_PARAMS }
        })
        const data = res?.data?.data || []
        if (Array.isArray(data) && data.length > 0) {
          this.directories = data.map(this.mapDirectoryRow)
        }
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchCategoryTree failed:', e)
      }
    },
    async fetchUnitPage() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind/units/page`,
          method: 'post',
          data: { ...COMMON_REQUEST_PARAMS, pageNum: 1, pageSize: 5 }
        })
        const data = res?.data || {}
        if (Number.isFinite(Number(data.total))) {
          this.unitTotal = Number(data.total)
        }
        if (Array.isArray(data.records) && data.records.length > 0) {
          this.unitRows = data.records.slice(0, 5).map((r) => ({
            name: r.name || '-',
            typeName:
              UNIT_TYPES.find((item) => item.value === r.typeCode)?.label ||
              '-'
          }))
        }
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchUnitPage failed:', e)
      }
    },
    async fetchLabelTree() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind/text-labels/tree`,
          method: 'get',
          params: { keyword: '' }
        })
        const data = res?.data || []
        console.log('[ res ]-806', res)
        if (Array.isArray(data)) {
          this.labelTotal = data?.length
          this.labelRows = data
        }
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchLabelTree failed:', e)
      }
    },
    async fetchLineagePreview() {
      try {
        const res = await request({
          url: `${bigdataUrl}/ind/derived-matrix/lineage`,
          method: 'post',
          data: {}
        })
        if (Array.isArray(res?.data)) {
          this.lineagePreview = res.data
        }
      } catch (e) {
        console.warn('[IndicatorAgentPage] fetchLineagePreview failed:', e)
      }
    },
    updateStatValue(label, value) {
      if (value === undefined || value === null || value === '') return
      const stat = this.stats.find((item) => item.label === label)
      if (stat) stat.value = value
    },
    updateElementValue(label, value) {
      if (value === undefined || value === null || value === '') return
      const stat = this.elementStats.find((item) => item.label === label)
      if (stat) stat.value = value
    },
    safeParseRemark(remark) {
      if (!remark) return null
      if (typeof remark === 'object') return remark
      try {
        return JSON.parse(remark)
      } catch (e) {
        console.warn('[IndicatorAgentPage] parse trend remark failed:', e)
        return null
      }
    },
    normalizeTrendBars(bars) {
      const numbers = bars
        .map((item) => Number(item))
        .filter((item) => Number.isFinite(item))
      if (numbers.length === 0) return this.trendBars
      return numbers.map((item) => Math.min(100, Math.max(0, item)))
    },
    mapMetricRow(record) {
      const typeMap = {
        0: { type: '原子指标', typeClass: 'atomic' },
        1: { type: '派生指标', typeClass: 'derived' },
        2: { type: '复合指标', typeClass: 'composite' }
      }
      const typeInfo = typeMap[Number(record.type)] || {
        type: '未知类型',
        typeClass: 'unknown'
      }
      return {
        name: record.name || '-',
        type: typeInfo.type,
        typeClass: typeInfo.typeClass,
        category: record.categoryName || '-'
      }
    },
    mapIndustryRow(record, index) {
      const iconMap = [
        'el-icon-office-building',
        'el-icon-data-analysis',
        'el-icon-cpu'
      ]
      return {
        id: record.id,
        icon: iconMap[index % iconMap.length],
        name: record.name || '-',
        desc: record.remark || '-',
        count: Number.isFinite(Number(record.count)) ? Number(record.count) : 0
      }
    },
    mapDirectoryRow(record) {
      return {
        id: record.id || record.code || record.name,
        name: record.name || '-',
        count: Array.isArray(record.children) ? record.children.length : 0
      }
    },
    handleSend(value) {
      if (value) this.handleOpenTab(value, value, '')
    },
    handleSceneClick(scene) {
      this.handleOpenTab(scene, scene, '')
    },
    handleStatClick(stat) {
      const urlMap = {
        atomic: BIGDATA_PATHS.atomicIndicators,
        derived: BIGDATA_PATHS.derivedIndicators,
        composite: BIGDATA_PATHS.compositeIndicators
      }
      const url = urlMap[stat.type] || ''
      if (url) {
        this.handleOpenTab(`stat-${stat.type}`, stat.label, url)
      }
    },
    sendTokenToIframe(iframe) {
      const token = getToken()
      if (!token) return
      iframe.contentWindow.postMessage(
        JSON.stringify({
          action: 'token_send',
          payload: {
            token,
            expireAt: Date.now()
          },
          timestamp: Date.now()
        }),
        '*'
      )
    },
    onIframeLoad(event, tab) {
      this.sendTokenToIframe(event.target)
    },
    handleOpenTab(id, title, url) {
      const exists = this.tabs.find((t) => t.id === id)
      if (!exists) {
        this.tabs.push({ id, title, url: url || '' })
      }
      this.activeTab = id
      if (url) {
        this.$nextTick(() => {
          setTimeout(() => {
            const iframe = this.$el.querySelector('.gov-iframe')
            if (iframe) this.sendTokenToIframe(iframe)
          }, 300)
        })
      }
    },
    closeTab(id) {
      const idx = this.tabs.findIndex((t) => t.id === id)
      if (idx === -1) return
      this.tabs.splice(idx, 1)
      if (this.activeTab === id) {
        this.activeTab = this.tabs.length
          ? this.tabs[this.tabs.length - 1].id
          : 'home'
      }
    },
    checkTenantVisibility() {
      const currentTenant = this.$store.state.user.currentTenant;
      const tenantId = currentTenant && currentTenant.id;
      if (tenantId != null) {
        this.showBuildCard = tenantId != 100022362;
      }
    },
  },
  computed: {
    trendGrowthText() {
      const value = Number(this.trendGrowthRate)
      if (!Number.isFinite(value)) return '+0%'
      return `${value >= 0 ? '+' : ''}${value}%`
    },
    totalElementCount() {
      return this.elementStats.reduce(
        (sum, item) => sum + (Number(item.value) || 0),
        0
      )
    },
    industryMetricTotal() {
      return this.industries.reduce(
        (sum, item) => sum + (Number(item.count) || 0),
        0
      )
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #4a5ff3;
$primary-soft: #eef2ff;
$text-main: #1f2a44;
$text-muted: #8fa0b8;

.indicator-board {
  width: 100%;
}

.quick-questions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.question-item {
  min-height: 64px;
  padding: 14px 18px;
  border: 1px solid rgba(226, 232, 240, 0.78);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  align-items: center;
  gap: 14px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;

  .q-icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: $primary-soft;
    color: #5b6ff8;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;

    i {
      font-size: 18px;
    }
  }

  .q-text {
    color: #26334d;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
  }

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(74, 95, 243, 0.22);
    box-shadow: 0 10px 24px rgba(74, 95, 243, 0.1);
  }
}

.stats-row {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.stat-list {
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.stat-card,
.trend-card,
.scene-card {
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.86);
  box-shadow: 0 12px 40px rgba(69, 96, 178, 0.12);
}

.stat-card {
  min-height: 88px;
  border-radius: 16px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;

}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  font-size: 18px;

  &.atomic {
    background: $primary-soft;
    color: $primary;
  }

  &.derived {
    background: #e8f8ef;
    color: #1a8a4a;
  }

  &.composite {
    background: #fef3e8;
    color: #d46b08;
  }
}

.stat-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-value {
  color: $text-main;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}

.stat-label {
  color: $text-muted;
  font-size: 12px;
  font-weight: 600;
}

.trend-card {
  width: 200px;
  flex: none;
  border-radius: 16px;
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.trend-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  span {
    color: $text-muted;
    font-size: 12px;
    white-space: nowrap;
  }

  strong {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    color: #1a8a4a;
    background: #e8f8ef;
    border-radius: 999px;
    padding: 2px 8px;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;
  }
}

.mini-chart {
  height: 32px;
  display: flex;
  align-items: flex-end;
  gap: 6px;

  span {
    width: 20px;
    border-radius: 3px 3px 0 0;
    background: $primary;
  }
}

.scene-card {
  border-radius: 20px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.22s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 32px rgba(74, 95, 243, 0.14);
  }
}

.build-card {
  margin-bottom: 20px;
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.card-title-wrap {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;

  h3 {
    margin: 0;
    color: $text-main;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.25;
  }

  p {
    margin: 4px 0 0;
    color: $text-muted;
    font-size: 12px;
    font-weight: 600;
  }
}

.feature-icon,
.item-icon {
  background: linear-gradient(135deg, #4e86ff 0%, $primary 100%);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  box-shadow: 0 8px 18px rgba(58, 108, 219, 0.18);
}

.feature-icon {
  width: 44px;
  height: 44px;
  border-radius: 16px;
  font-size: 18px;
}

.link-pill {
  border: 0;
  border-radius: 999px;
  background: $primary-soft;
  color: $primary;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

.build-flow {
  border: 1px solid rgba(226, 232, 240, 0.74);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.6);
  padding: 24px 18px 28px;
  display: flex;
  align-items: flex-start;
  gap: 0;
}

.flow-item {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;

  &:last-child {
    flex: 1.12;
  }
}

.flow-content {
  flex: 1;
  min-width: 0;
}

.flow-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  white-space: nowrap;

  span {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: $primary;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;
    font-size: 13px;
    font-weight: 700;
  }

  strong {
    color: #26334d;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.25;
    white-space: nowrap;
  }
}

.flow-content p {
  width: 92px;
  margin: 0 0 0 36px;
  color: $text-muted;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.45;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.flow-arrow {
  color: #cbd5e1;
  flex: none;
  font-size: 22px;
  padding: 6px 12px 0 8px;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.metric-table,
.element-panel,
.industry-list,
.directory-list {
  position: relative;
  border: 1px solid rgba(226, 232, 240, 0.74);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.58);
  overflow: hidden;
  height: calc(100% - 56px);
  padding-bottom: 30px;
}

.directory-list  {
  max-height: 300px;
  overflow-y: auto;
}

.table-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 38px;
  padding: 0 16px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);
  color: #26334d;
  font-size: 13px;
  font-weight: 600;
  span {
    flex: 1;
    text-align: center;
    &:first-child {
      text-align: left;
    }
  }

  span:last-child {
    color: $text-muted;
  }
}

.table-head {
  min-height: 42px;
  background: rgba(248, 250, 252, 0.86);
  color: #64748b;

  span:last-child {
    color: #64748b;
  }
}

.type-tag {
  display: inline-flex;
  border-radius: 5px;
  padding: 3px 8px;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 1;

  &.atomic {
    background: $primary-soft;
    color: $primary;
  }

  &.derived {
    background: #e8f8ef;
    color: #1a8a4a;
  }

  &.composite {
    background: #fef3e8;
    color: #d46b08;
  }

  &.unknown {
    background: #f4f7fb;
    color: #8fa0b8;
  }
}

.table-footer,
.panel-footer {
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $text-muted;
  background: rgba(255, 255, 255, 0.72);
  font-size: 12px;
  font-weight: 600;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.element-panel {
  padding: 18px 18px 0;
}

.element-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.element-stat {
  min-height: 100px;
  border: 1px solid rgba(226, 232, 240, 0.74);
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  span {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: $primary-soft;
    color: $primary;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  strong {
    color: $text-main;
    font-size: 16px;
    line-height: 1;
  }

  small {
    color: $text-muted;
    font-size: 12px;
    font-weight: 600;
  }
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0 8px;

  span {
    border: 1px solid rgba(226, 232, 240, 0.9);
    border-radius: 5px;
    background: #fff;
    color: #475569;
    padding: 6px 12px;
    font-size: 12px;
  }
}

.industry-list {
  padding: 16px 16px 0;
}

.industry-item {
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid rgba(226, 232, 240, 0.78);
  border-radius: 14px;
  background: #fff;
  padding: 14px 16px;
  margin-bottom: 14px;

  .item-icon {
    width: 42px;
    height: 42px;
    border-radius: 14px;
  }

  div {
    flex: 1;
    min-width: 0;
  }

  strong {
    color: #26334d;
    font-size: 13px;
    font-weight: 700;
  }

  p {
    margin: 4px 0 0;
    color: $text-muted;
    font-size: 11px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  em {
    border-radius: 999px;
    background: $primary-soft;
    color: $primary;
    padding: 4px 12px;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    white-space: nowrap;
  }
}

.lineage-preview-wrap {
  border: 1px solid rgba(226, 232, 240, 0.74);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.58);
  overflow: hidden;
}

.lineage-preview-scroll {
  height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 12px 0;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  &:hover {
    scrollbar-color: rgba(148, 163, 184, 0.5) transparent;
  }
  &::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 2px;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.5);
  }
}

.lineage-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid rgba(226, 232, 240, 0.74);
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
}

.lineage-badge {
  display: inline-block;
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 999px;
  font-weight: 500;
  white-space: nowrap;
  &.indicator {
    background: $primary-soft;
    color: $primary;
  }
}

.lineage-info {
  flex: 1;
  min-width: 0;
  .lineage-name {
    font-size: 13px;
    font-weight: 600;
    color: #26334d;
  }
  .lineage-deps {
    font-size: 11px;
    color: $text-muted;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.lineage-count {
  font-size: 11px;
  font-weight: 500;
  color: $primary;
  background: $primary-soft;
  border-radius: 999px;
  padding: 2px 10px;
  white-space: nowrap;
}

.lineage-footer {
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $text-muted;
  background: rgba(255, 255, 255, 0.72);
  font-size: 12px;
  font-weight: 600;
  border-top: 1px solid rgba(226, 232, 240, 0.74);
}

.directory-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 47px;
  padding: 0 18px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);

  &:last-child {
    border-bottom: 0;
  }

  span {
    color: #26334d;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    font-weight: 600;

    i {
      color: $primary;
      font-size: 13px;
    }
  }

  em {
    border-radius: 999px;
    background: $primary-soft;
    color: $primary;
    padding: 4px 11px;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
  }
}

// @media (max-width: 1200px) {
//   .quick-questions,
//   .feature-grid {
//     grid-template-columns: repeat(2, minmax(0, 1fr));
//   }

//   .stats-row,
//   .build-flow {
//     flex-direction: column;
//   }

//   .trend-card {
//     width: 100%;
//   }

//   .flow-item {
//     width: 100%;
//   }

//   .flow-arrow {
//     display: none;
//   }
// }

@media (max-width: 768px) {
  .quick-questions,
  .stat-list,
  .feature-grid,
  .element-summary {
    grid-template-columns: 1fr;
  }

  .card-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .table-row {
    grid-template-columns: 1fr 0.9fr 0.9fr;
    padding: 0 12px;
  }
}

.gov-shell {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.gov-tab-bar {
  display: flex;
  gap: 4px;
  padding: 8px 20px;
  overflow-x: auto;
  white-space: nowrap;
  flex-wrap: nowrap;
  flex-shrink: 0;
}
.gov-tab {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  line-height: 1;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #595959;
  flex-shrink: 0;
}
.gov-tab:hover {
  background: rgba(255, 255, 255, 0.8);
}
.gov-tab.active {
  background-image: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}
.gov-tab.active .tab-title {
  color: #fff;
}
.gov-tab.active .tab-close {
  color: #fff;
}
.tab-title {
  font-size: 13px;
  color: #666;
  font-family: PingFangSC-Regular;
}
.tab-close {
  font-size: 12px;
  color: #999;
}
.gov-iframe-wrap {
  flex: 1;
  min-height: 0;
  padding: 12px;
}
.gov-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.open-tab-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.open-tab-link {
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid rgba(74, 95, 243, 0.2);
  background: linear-gradient(
    135deg,
    rgba(74, 95, 243, 0.06),
    rgba(45, 127, 249, 0.03)
  );
  color: #4a5ff3;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.open-tab-link:hover {
  background: linear-gradient(
    135deg,
    rgba(74, 95, 243, 0.12),
    rgba(45, 127, 249, 0.08)
  );
  border-color: rgba(74, 95, 243, 0.4);
  transform: translateY(-1px);
}
</style>
